<template>
  <div class="page">
    <div class="list-view">
      <ud-empty-row />
      <p class="title">用户协议</p>
      <ud-empty-row />
      <p class="info">憬悦管家软件许可及服务协议</p>
      <p class="info">感谢您使用憬悦管家产品！为使用憬悦管家软件（以下简称“本软件”）及服务，您应当阅读并遵守《憬悦管家软件许可及服务协议》（以下简称“本协议”）。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，以及使用某项服务的单独协议，并选择接受或不接受。限制、免责条款可能以加粗形式提示您注意。除非您已阅读并接受本协议所有条款，否则您无权下载、安装或使用本软件及相关服务。您的下载、安装、使用、获取憬悦管家帐号、登录等行为即视为您已阅读并同意上述协议的约束。如果您未满18周岁，请在法定监护人的陪同下阅读本协议及其他上述协议，并特别注意未成年人使用条款。</p>
      <p class="info">一、协议的范围</p>
      <p class="info">1.1 协议适用主体范围</p>
      <p class="info">本协议是您与深圳市景悦科技有限公司（以下简称“景悦”）之间关于您下载、安装、使用、复制本软件，以及使用相关服务所订立的协议。</p>
      <p class="info">1.2 免责说明</p>
      <p class="info">本协议只作用于憬悦管家和终端用户之间，憬悦管家对授权的应用程序和内容负有全部责任。本协议不对已经有更严格使用规定的已许可应用程序，或者超出App Store服务条款有效日期的已许可程序的使用规定，作出规定。</p>
      <p class="info">二、关于本服务</p>
      <p class="info">2.1 本服务的内容</p>
      <p class="info">本服务内容是指景悦与物业管理公司及商业机构（以下共称“合作第三方”）合作运营的，共同向用户提供的跨平台的物业管理服务、通信服务、商业服务等的社区综合管理服务工具（以下简称“憬悦管家”）的软件许可及服务（以下简称“本服务”）。</p>
      <p class="info">2.2 本服务的形式</p>
      <p class="info">2.2.1 您使用本服务需要下载憬悦管家客户端软件，对于这些软件，景悦给予您一项个人的、不可转让及非排他性的许可。您仅可为访问或使用本服务的目的而使用这些软件及服务。</p>
      <p class="info">2.2.2 本服务中憬悦管家客户端软件提供包括但不限于ios、android等多个应用版本，用户必须选择与所安装手机相匹配的软件版本。</p>
      <p class="info">2.3 本服务许可的范围</p>
      <p class="info">2.3.1 景悦给予您一项个人的、不可转让及非排他性的许可，以使用本软件。您可以为非商业目的在单一台终端设备上安装、使用、显示、运行本软件</p>
      <p class="info">2.3.2 您可以为使用本软件及服务的目的复制本软件的一个副本，仅用作备份。备份副本必须包含原软件中含有的所有著作权信息。</p>
      <p class="info">2.3.3 本条及本协议其他条款未明示授权的其他一切权利仍由景悦保留，您在行使这些权利时须另外取得景悦的书面许可。如果景悦未行使前述任何权利，并不构成对该权利的放弃。</p>
      <p class="info">三、软件的获取</p>
      <p class="info">3.1 您可以直接从的景悦网站上获取本软件，也可以从得到授权的第三方获取</p>
      <p class="info">3.2 如果您从未经景悦授权的第三方获取本软件或与本软件名称相同的安装程序，景悦无法保证该软件能够正常使用，并对因此给您造成的损失不予负责。</p>
      <p class="info">四、软件的安装与卸载</p>
      <p class="info">4.1 景悦可能为不同的终端设备开发了不同的软件版本，您应当根据实际情况选择下载合适的版本进行安装。</p>
      <p class="info">4.2 下载安装程序后，您需要按照该程序提示的步骤正确安装。</p>
      <p class="info">4.3 如果您不再需要使用本软件或者需要安装新版软件，可以自行卸载。如果您愿意帮助改进产品服务，请告知卸载的原因。</p>
      <p class="info">五、软件的更新</p>
      <p class="info">5.1 为了改善用户体验、完善服务内容，景悦将不断努力开发新的服务，并为您不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）。</p>
      <p class="info">5.2 为了保证本软件及服务的安全性和功能的一致性，景悦有权不经向您特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。</p>
      <p class="info">5.3 本软件新版本发布后，旧版本的软件可能无法使用。景悦不保证旧版本软件继续可用及相应的客户服务，请您随时核对并下载最新版本。</p>
      <p class="info">六、用户个人信息保护</p>
      <p class="info">6.1 保护用户个人信息是景悦的一项基本原则，景悦将会采取合理的措施保护用户的个人信息。除法律法规规定的情形外，景悦未经用户许可不会向非用户居住社区的物业管理公司以外的任何机构或个人公开、透露用户个人信息。对相关信息采用专业加密存储与传输方式，保障用户个人信息的安全。</p>
      <p class="info">在您使用憬悦管家的产品及服务前，您应按照憬悦管家注册登录页面的提示填写信息、阅读并点击同意本协议且完成全部账号注册激活程序，成为憬悦管家的用户。</p>
      <p class="info">6.2 您在注册帐号或使用本服务的过程中，需要提供一些必要的信息，例如：为向您提供帐号注册服务或进行用户身份识别，需要您填写手机号码；天气信息功能需要您同意使用您所在的地理位置信息等。若国家法律法规或政策有特殊规定的，您需要提供真实的身份信息。若您提供的信息不完整，则无法使用本服务或在使用过程中受到限制。</p>
      <p class="info">6.3 一般情况下，您可随时浏览、修改自己提交的信息，但出于安全性和身份识别的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。</p>
      <p class="info">6.4 景悦将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。</p>
      <p class="info">6.5 未经您的同意，景悦不会向非用户居住社区的物业管理公司以外的任何公司、组织和个人披露您的个人信息，但法律法规另有规定的除外。</p>
      <p class="info">6.6 景悦非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用服务前，应事先取得您家长或法定监护人的书面同意。</p>
      <p class="info">七、主权利义务条款</p>
      <p class="info">7.1 帐号使用规范</p>
      <p class="info">7.1.1 您在使用本服务前需要注册一个憬悦管家帐号。憬悦管家帐号可通过手机号码进行注册。</p>
      <p class="info">7.1.2 憬悦管家帐号的所有权归景悦所有，用户完成申请注册手续后，仅获得憬悦管家帐号的使用权，且该使用权仅属于初始申请注册人。同时，初始申请注册人不得赠与、借用、租用、转让或售卖憬悦管家帐号或者以其他方式许可非初始申请注册人使用憬悦管家帐号。非初始申请注册人不得通过受赠、继承、承租、受让或者其他任何方式使用憬悦管家账号。</p>
      <p class="info">7.1.3 用户有责任妥善保管注册帐户信息及帐户密码的安全，用户需要对注册帐户以及密码下的行为承担法律责任。用户同意在任何情况下不向他人透露帐户及密码信息。当在您怀疑他人在使用您的帐号时，您应立即通知景悦或所居住社区的物业管理公司。</p>
      <p class="info">7.1.4 用户注册憬悦管家帐号后如果长期不登录该帐号，景悦有权取消该帐号，以免造成资源浪费，由此带来的任何损失均由用户自行承担。</p>
      <p class="info">7.2 用户注意事项</p>
      <p class="info">7.2.1 您理解并同意：为了向您提供有效的服务，本软件会利用您移动通讯终端的处理器和带宽等资源。本软件使用过程中可能产生数据流量的费用，用户需自行向运营商了解相关资费信息，并自行承担相关费用。</p>
      <p class="info">7.2.2 您理解并同意：本软件的某些功能可能会让第三方知晓用户的信息，例如：与用户居住在同一社区的其他用户可以查询用户头像、昵称等可公开的个人资料。</p>
      <p class="info"> 7.2.3 您在使用本软件某一特定服务时，该服务可能会另有单独的协议、相关业务规则等（以下统称为“单独协议”），您在使用该项服务前请阅读并同意相关的单独协议。</p>
      <p class="info">7.2.4 您理解并同意将会尽其商业上的合理努力保障您在本软件及服务中的数据存储安全，但是，景悦并不能就此提供完全保证，包括但不限于以下情形：</p>
      <p class="info">7.2.4.1 景悦不对您在本软件及服务中相关数据的删除或储存失败负责；</p>
      <p class="info">7.2.4.2 景悦有权根据实际情况自行决定单个用户在本软件及服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。您可根据自己的需要自行备份本软件及服务中的相关数据；</p>
      <p class="info">7.2.4.3 如果您停止使用本软件及服务或服务被终止或取消，可以从服务器上永久地删除您的数据。服务停止、终止或取消后，景悦没有义务向您返还任何数据。</p>
      <p class="info">7.2.5 用户在使用本软件及服务时，须自行承担如下来自不可掌控的风险内容，包括但不限于：</p>
      <p class="info">7.2.5.1 由于不可抗拒因素可能引起的个人信息丢失、泄漏等风险；</p>
      <p class="info">7.2.5.2 用户必须选择与所安装手机相匹配的软件版本，否则，由于软件与手机型号不相匹配所导致的任何问题或损害，均由用户自行承担；</p>
      <p class="info">7.2.5.3 用户在使用本软件访问第三方网站时，因第三方网站及相关内容所可能导致的风险，由用户自行承担；</p>
      <p class="info">7.2.5.4 用户发布的内容被他人转发、分享，因此等传播可能带来的风险和责任；</p>
      <p class="info">7.2.5.5 由于无线网络信号不稳定、无线网络带宽小等原因，所引起的憬悦管家登录失败、资料同步不完整、页面打开速度慢等风险。</p>
      <p class="info">7.3 第三方产品和服务</p>
      <p class="info">7.3.1 您在使用本软件合作第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。景悦和合作第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。</p>
      <p class="info">7.3.2 因用户使用本软件或要求提供特定服务时，本软件可能会调用合作第三方系统或者通过合作第三方支持用户的使用或访问，使用或访问的结果由该合作第三方提供，不保证通过合作第三方提供服务及内容的安全性、准确性、有效性及其他不确定的风险，由此若引发的任何争议及损害，与景悦无关，不承担任何责任。</p>
      <p class="info">八、用户行为规范</p>
      <p class="info">8.1 信息内容规范</p>
      <p class="info">8.1.1 本条所述信息内容是指用户使用本软件及服务过程中所制作、复制、发布、传播的任何内容，包括但不限于憬悦管家帐号头像、昵称、用户说明等注册信息，以及其他使用憬悦管家帐号或本软件及服务所产生的内容。</p>
      <p class="info">8.1.2 您理解并同意，憬悦管家致力于为用户提供文明健康、规范有序的网络环境，您不得利用憬悦管家帐号或本软件及服务制作、复制、发布、传播如下干扰憬悦管家正常运营，以及侵犯其他用户或第三方合法权益的内容，包括但不限于：</p>
      <p class="info">8.1.2.1 发布、传送、传播、储存违反国家法律法规禁止的内容：</p>
      <p class="info">（1）违反宪法确定的基本原则的；</p>
      <p class="info">（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
      <p class="info">（3）损害国家荣誉和利益的；</p>
      <p class="info">（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
      <p class="info">（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
      <p class="info">（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
      <p class="info">（7）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>
      <p class="info">（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
      <p class="info">（9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；</p>
      <p class="info">（10）以非法民间组织名义活动的；</p>
      <p class="info">（11）不符合遵守法律法规、社会主义制度、国家利益、公民合法利益、公共秩序、社会道德风尚和信息真实性等“七条底线”要求的；</p>
      <p class="info">（12）含有法律、行政法规禁止的其他内容的。</p>
      <p class="info">8.1.2.2 发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</p>
      <p class="info">8.1.2.3 涉及他人隐私、个人信息或资料的；</p>
      <p class="info">8.1.2.4 发表、传送、传播骚扰、广告信息及垃圾信息或含有任何性或性暗示的；</p>
      <p class="info">8.1.2.5 其他违反法律法规、政策及公序良俗、社会公德或干扰憬悦管家正常运营和侵犯其他用户或合作第三方合法权益内容的信息。</p>
      <p class="info">8.2 软件使用规范</p>
      <p class="info">除非法律允许或书面许可，您使用本软件过程中不得从事下列行为：</p>
      <p class="info">8.2.1 删除本软件及其副本上关于著作权的信息；</p>
      <p class="info">8.2.2 对本软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本软件</p>
    </div>
  </div>
</template>

<script>
import UdEmptyRow from '@/components/ud-empty-row'

export default {
  components: {
    UdEmptyRow
  }
}
</script>

<style lang="scss" scoped>
.page {
  padding: 24px;
  box-sizing: border-box;
}

.list-view {
  flex: 1;
  @include relative;
}

.title {
  @include text(28px);
  text-align: center;
}

.info {
  margin-bottom: 12px;
  @include text(22px);
  line-height: 1.2;
  @extend .flex-row;
  justify-content: space-between;
}
</style>